export const ConstantInfo = {
    phone: 'tel:+37259276691',
    phoneView: '+372 5927 6691',
    email: 'mailto:support@dme-tech.com?subject=',
    emailView: 'support@dme-tech.com',
  }